import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthProvider';
import { supabase } from '../lib/supabase';

/**
 * Whether the current user is granted `feature` (via feature_grants / the
 * has_feature_access RPC). `access` is null while loading, then true/false.
 * Not logged in or auth unconfigured → false (the backend is the real gate).
 */
export function useFeatureAccess(feature: string) {
  const { user, loading: authLoading, configured } = useAuth();
  const [access, setAccess] = useState<boolean | null>(null);

  useEffect(() => {
    if (authLoading) return;
    if (!configured || !user) {
      setAccess(false);
      return;
    }
    let cancelled = false;
    setAccess(null);
    supabase.rpc('has_feature_access', { p_feature: feature }).then(({ data, error }) => {
      if (!cancelled) setAccess(!error && data === true);
    });
    return () => {
      cancelled = true;
    };
  }, [feature, user, configured, authLoading]);

  return { access, loading: authLoading || access === null };
}
